module.exports = "/resources/assets/prod/282231aa1535537f45709c70e3511877.jpg";